export default "__VITE_ASSET__Nypu80PZ__"